<script>
  export let compact = false;
</script>

<div class="senate-key" aria-hidden="true">
  <div
    class="senate-key__labels"
    class:text-base={!compact}
    class:text-sm={compact}
  >
    <span>Current seat</span>
    <span>Winner</span>
  </div>

  <svg
    class="senate-key__square"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="2"
      width="36"
      height="36"
      fill="#cecccc"
      stroke="#777"
      stroke-width="4"
    />

    <line x1="38" y1="12" x2="62" y2="12" />
    <line x1="20" y1="28" x2="62" y2="28" />
  </svg>

  <div class="senate-key__no-contest">
    <span
      class="senate-key__no-contest-label"
      class:text-base={!compact}
      class:text-sm={compact}
    >
      <span>No</span>
      <span>contest</span>
    </span>

    <svg
      class="senate-key__square"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      aria-hidden="true"
    >
      <rect
        class="senate-key__dem"
        width="40"
        height="40"
      />
    </svg>

    <svg
      class="senate-key__square"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      aria-hidden="true"
    >
      <rect
        class="senate-key__gop"
        width="40"
        height="40"
      />
    </svg>
  </div>
</div>